import { Injectable } from '@angular/core';
import { NavigationDropdown, NavigationItem, NavigationLink, NavigationSubheading } from '../interfaces/navigation-item.interface';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private navigationItemSubject = new Subject<NavigationItem[]>();
  Items: NavigationItem[] = [];
  private breadCrumbsSubject = new Subject<any[]>();
  private _openChangeSubject = new Subject<NavigationDropdown>();
  openChange$ = this._openChangeSubject.asObservable();
  BreadCrumbs: any = [];
  constructor() { }

  triggerOpenChange(item: NavigationDropdown) {
    this._openChangeSubject.next(item);
  }

  isLink(item: NavigationItem): item is NavigationLink {
    return item.type === 'link';
  }

  isDropdown(item: NavigationItem): item is NavigationDropdown {
    return item.type === 'dropdown';
  }

  isSubheading(item: NavigationItem): item is NavigationSubheading {
    return item.type === 'subheading';
  }

  setItem(items) {
    this.Items = items;
    this.navigationItemSubject.next(items);
  }

  setBreadCrumbs(breadcrumbs){
    this.BreadCrumbs = breadcrumbs;
  }

  getItem() {
    return this.navigationItemSubject.asObservable();
  }

  getBreadcrumbs() {
    return this.BreadCrumbs;
  }
}
